export default __webpack_public_path__ + "static/media/logo-axa.91589cc8.svg";